export const CARE_HOME_ARTICLES = [
  {
    filter: {},
    to:
      "https://www.caresourcer.com/caresupport/arranging-care/choose-right-care-home/",
    header: "How to choose the right care home",
    snippet:
      "When it comes to choosing the right care home, the first thing to decide is whether a nursing or residential home is required ...",
  },
  {
    filter: {},
    to:
      "https://www.caresourcer.com/caresupport/understanding-care/care-needs-assessment/",
    header: "How to book a care needs assessment - and why you should",
    snippet:
      "Been advised to book a care needs assessment? It's one of the first steps on the road to securing the right type of care package...",
  },
  {
    filter: {
      regulatoryBody: "cqc",
    },
    to:
      "https://www.caresourcer.com/caresupport/understanding-care/what-is-care-quality-commission/",
    header: "What is the Care Quality Commission (CQC)?",
    snippet:
      "The CQC is an independent regulator for all care providers in England, carrying out regular comprehensive inspections ...",
  },
  {
    filter: {
      regulatoryBody: "ci",
    },
    to:
      "https://www.caresourcer.com/caresupport/understanding-care/what-is-care-inspectorate/",
    header: "What is the Care Inspectorate (CI)?",
    snippet:
      "The CI is an independent regulator for all care providers in Scotland, carrying out regular comprehensive inspections...",
  },
  {
    filter: {},
    to:
      "https://www.caresourcer.com/caresupport/arranging-care/meeting-care-providers/",
    header:
      "10 questions you should ask when meeting with potential care providers",
    snippet:
      "Take a note of 10 key questions to ask a prospective care provider. Are you planning to meet with potential care providers? Wo…",
  },
]

export const HOME_CARE_ARTICLES = [
  {
    filter: {
      regulatoryBody: "cqc",
    },
    to:
      "https://www.caresourcer.com/caresupport/financing-care/paying-for-care-at-home-in-england/",
    header: "Paying for care at home in England",
    snippet:
      "Charged on an hourly basis, care at home in England tends to be more affordable than moving to a care home...",
  },
  {
    filter: {
      regulatoryBody: "ci",
    },
    to:
      "https://www.caresourcer.com/caresupport/financing-care/in-home-care-costs-scotland-home-care-package-costs/",
    header: "Paying for care at home in Scotland",
    snippet:
      "Charged on an hourly basis, care at home in Scotland tends to be more affordable than moving to a care home...",
  },
  {
    filter: {
      regulatoryBody: "cqc",
    },
    to:
      "https://www.caresourcer.com/caresupport/understanding-care/what-is-care-quality-commission/",
    header: "What is the Care Quality Commission (CQC)?",
    snippet:
      "The CQC is an independent regulator for all care providers in England, carrying out regular comprehensive inspections ...",
  },
  {
    filter: {
      regulatoryBody: "ci",
    },
    to:
      "https://www.caresourcer.com/caresupport/understanding-care/what-is-care-inspectorate/",
    header: "What is the Care Inspectorate (CI)?",
    snippet:
      "The CI is an independent regulator for all care providers in Scotland, carrying out regular comprehensive inspections...",
  },
  {
    filter: {},
    to:
      "https://www.caresourcer.com/caresupport/arranging-care/six-questions-you-should-ask-home-care-agencies-about-their-services/",
    header: "Six questions to ask home care agencies",
    snippet:
      "To help you find the right care agency for your loved one, we’ve created a list of questions you can ask home care agencies...",
  },
  {
    filter: {},
    to:
      "https://www.caresourcer.com/caresupport/understanding-care/what-is-domiciliary-care-care-at-home-explained/",
    header: "What is care at home?",
    snippet:
      "Domiciliary care is when a carer either visits you or lives in your own home, in order to help you with a range of different tasks...",
  },
]

export const AGNOSTIC_CARE_ARTICLES = [
  {
    filter: {},
    to:
      "https://www.caresourcer.com/caresupport/understanding-care/care-needs-assessment/",
    header: "How to book a care needs assessment - and why you should",
    snippet:
      "Been advised to book a care needs assessment? It's one of the first steps on the road to securing the right type of care package...",
  },
  {
    filter: {},
    to:
      "https://www.caresourcer.com/caresupport/understanding-care/how-to-compare-care-homes-and-evaluate-domiciliary-care-providers/",
    header: "How to compare care options",
    snippet:
      "Whether you’re seeking care at home, or a care home place, the process for evaluating care providers involves many of the same considerations..",
  },
  {
    filter: {},
    to:
      "https://www.caresourcer.com/caresupport/financing-care/how-much-does-care-cost/",
    header: "How much does elderly care cost",
    snippet:
      "The cost of paying for care varies depending on the type of care and where you live within the UK...",
  },
  {
    filter: {
      regulatoryBody: "cqc",
    },
    to:
      "https://www.caresourcer.com/caresupport/understanding-care/what-is-care-quality-commission/",
    header: "What is the Care Quality Commission (CQC)?",
    snippet:
      "The CQC is an independent regulator for all care providers in England, carrying out regular comprehensive inspections ...",
  },
  {
    filter: {
      regulatoryBody: "ci",
    },
    to:
      "https://www.caresourcer.com/caresupport/understanding-care/what-is-care-inspectorate/",
    header: "What is the Care Inspectorate (CI)?",
    snippet:
      "The CI is an independent regulator for all care providers in Scotland, carrying out regular comprehensive inspections...",
  },
]

export const DEMENTIA_CARE_HOME_ARTICLES = [
  {
    filter: {},
    to:
      "https://www.caresourcer.com/caresupport/dementia/worried-about-dementia/",
    header: "5 tips to live well with dementia?",
    snippet:
      "Anybody managing dementia will have bad days as well as good ones, but an emphasis on living a healthier life...",
  },
  {
    filter: {
      regulatoryBody: "cqc",
    },
    to:
      "https://www.caresourcer.com/caresupport/understanding-care/what-is-care-quality-commission/",
    header: "What is the Care Quality Commission (CQC)?",
    snippet:
      "The CQC is an independent regulator for all care providers in England, carrying out regular comprehensive inspections...",
  },
  {
    filter: {
      regulatoryBody: "ci",
    },
    to:
      "https://www.caresourcer.com/caresupport/understanding-care/what-is-care-inspectorate/",
    header: "What is the Care Inspectorate (CI)?",
    snippet:
      "The CI is an independent regulator for all care providers in Scotland, carrying out regular comprehensive inspections...",
  },
  {
    filter: {},
    to:
      "https://www.caresourcer.com/caresupport/arranging-care/meeting-care-providers/",
    header:
      "10 questions you should ask when meeting with potential care providers",
    snippet:
      "Take a note of 10 key questions to ask a prospective care provider. Are you planning to meet with potential care providers? Wo...",
  },
  {
    filter: {},
    to:
      "https://www.caresourcer.com/caresupport/arranging-care/moving-into-a-care-home/",
    header: "Tips for moving into a care home",
    snippet:
      "Moving anywhere can be an upheaval, but a move to a care home can bring added concern for the prospective resident and their families...",
  },
]
